import React, { Component } from 'react';
import '../../../styles/global.scss';
import UnitChart from "./unit-chart";
import * as moment from "moment";
import {UtilityColors} from "../constants/chart-color-constants";
import {createLineDataSetFrom} from "../../../helpers/chart-dataset-helpers";
import { withRouter } from 'react-router-dom';


class ConsumptionChart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            labels: this.generateLabels(props.data),
            datasets: this.generateConsumptionDataset(props.data),
            options: this.generateConsumptionOptions()
        };
    }

    componentDidUpdate(prevProps) {
        if (this.props.data !== prevProps.data) {
            this.setState({
                labels: this.generateLabels(this.props.data),
                datasets: this.generateConsumptionDataset(this.props.data),
                // options could be left as is if they don't depend on data changes
                // options: this.generateConsumptionOptions()
            });
        }
    }
    generateLabels = (data) => {
        return data.map(x => {
            const date = moment(new Date(x.date));
            return date.format("MMM YYYY");
        });
    }

    generateConsumptionDataset = (data) => {
        return [
            createLineDataSetFrom(data, "gas", "Gas", UtilityColors.gas, "kwh"),
            createLineDataSetFrom(data, "electricity", "Electricity", UtilityColors.electricity, "kwh"),
            createLineDataSetFrom(data, "water", "Water", UtilityColors.water, "m3"),
        ];
    }

    generateConsumptionOptions() {
        return {
            scales: {
                xAxes: [
                    {
                        ticks: {
                            fontSize: this.props.size === "compress" ? 9 : 12 // Change font size based on size prop
                        }
                    }
                ],
                yAxes: [
                    {
                        id: "kwh",
                        type: 'linear',
                        position: 'left',
                        scaleLabel: {
                            display: this.props.size === "compress" ? false : true,
                            labelString: 'Total Gas/Elec Consumption (kWh)',
                            fontStyle: "bold"
                        },
                        gridLines: {
                            drawOnChartArea: false, // only want the grid lines for one axis to show up
                        },
                        ticks: {
                            beginAtZero: true,
                            userCallback: function(value, index, values) {
                                return value.toLocaleString();   // this is all we need
                            },
                            fontSize: this.props.size === "compress" ? 9 : 12 // Change font size based on size prop

                        },
                    },
                    {
                        id: "m3",
                        type: 'linear',
                        position: 'right',
                        scaleLabel: {
                            display: this.props.size === "compress" ? false : true,
                            labelString: 'Total Water Consumption (m3)',
                            fontStyle: "bold"
                        },
                        gridLines: {
                            drawOnChartArea: false, // only want the grid lines for one axis to show up
                        },
                        ticks: {
                            beginAtZero: true,
                            userCallback: function(value, index, values) {
                                return value.toLocaleString();   // this is all we need
                            },
                            fontSize: this.props.size === "compress" ? 9 : 12 // Change font size based on size prop

                        },
                    }
                ]
            },
            legend: {
                position: 'bottom',
                display : this.props.size === "compress" ? false : true

            },
            title: {
                text: "Monthly Consumption",
                display: true,
                fontSize: this.props.size === "compress" ? 9 : 13
            },
                onClick: this.props.onElementsClick || ((evt, element) => {
                if (element.length > 0) {
                 
                    const firstPoint = element[0]._chart.getElementAtEvent(evt)[0];

               
                    const datasetIndex = firstPoint._datasetIndex;
                    const index = firstPoint._index;
                    const datasetLabel = this.state.datasets[datasetIndex].label;
                    const date = this.props.data[index].date;
    
                    // Format the date and construct query parameters
                    var queryParams = new URLSearchParams({
                      date: moment(date).format("YYYY-MM-DD"),
                      utility: datasetLabel.toLowerCase(),
                    }).toString();
                    var url = `/supplier-invoices?${queryParams}`;

                    if(this.props.selectedRowKey && this.props.selectedRowKey !== '' && this.props.selectedRowKey !== 'undefined')
                    {

                         queryParams = new URLSearchParams({
                            siteKey : this.props.selectedRowKey,
                            utility: datasetLabel.toLowerCase(),
                            tab : "supplier-invoices",
                            date: moment(date).format("YYYY-MM-DD")
            
                          }).toString();
                        url = `/site?${queryParams}`;
            

                    }
    
                    // Use React Router's history object to navigate

                    setTimeout(() => {

                        this.props.history.push(url);
                        },10 * 60)                }
            })
        };
    }

    render() {
        return (
            <UnitChart size={this.props.size} datasets={this.state.datasets} labels={this.state.labels} options={this.state.options}/>
        )
    }
}

export default withRouter(ConsumptionChart);